var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { GridList, GridTile, GridTilePrimary, GridTileSecondary, } from '@rmwc/grid-list';
import Icon from './Icon';
// TODO: Replace anchor tag with Link from context consumer (connect to context provider)
export default function Apps(_a) {
    var data = _a.data, _b = _a.className, className = _b === void 0 ? '' : _b;
    //
    var renderContent = function (item) {
        var icon = __assign(__assign({}, item.icon), { color: '#fff' });
        return (React.createElement(GridTile, { className: "madonna-apps-item" },
            React.createElement(GridTilePrimary, { className: "madonna-apps-icon" },
                React.createElement(Icon, __assign({}, icon))),
            React.createElement(GridTileSecondary, { className: "madonna-apps-title" }, item.title)));
    };
    return (React.createElement(GridList, { tileAspect: "1x1", className: "madonna-apps " + className }, data.map(function (item) { return item.to ? (React.createElement("a", { href: item.to }, renderContent(item))) : renderContent(item); })));
}
//# sourceMappingURL=Apps.js.map